import "./HomePage.css"
import React, { useCallback, useEffect, useRef } from "react";
import { isHomeSite } from "lib/legacy";
import { useWeb3React } from "@web3-react/core";
import { Link } from "react-router-dom";
import { HeaderLink } from "components/Header/HeaderLink";
import { CHAIN_ID } from "config/chains";
import { switchNetwork } from "lib/wallets";
import { useChainId } from "lib/chains";
import Watch from "img/watch.png"
import CardImg1 from "img/C1.png"
import CardImg2 from "img/C2.png"
import CardImg3 from "img/C3.png"
import CardImg4 from "img/C4.png"
import centerImg from 'img/C5.png'
import centerImg1 from 'img/C6.png'
import smallBannerBr from "img/home-smallBanner.png"
import Footer from "components/Footer/Footer";
import { Trans, t } from "@lingui/macro";
import githubIcon from "img/discord_line.svg";
import youtubeIcon from "img/youtube_line.svg";
import telegramIcon from "img/telegram_line.svg";
import twitterIcon from "img/twitter_line.svg";
import mediumIcon from "img/medium-line.svg"
import frameIcon from "img/frame.svg"
import smallFrameIcon from "img/small_Frame.svg"
import smallDiscordIcon from "img/small_discord_line.svg"
import smallMediumIcon from "img/small_medium.svg"
import smallTelegramIcon from "img/smalltelegram_line.svg"
import smallTwitterIcon from "img/small_twitter_line.svg"
import smallYoutubeIcon from "img/small_youtube_line.svg"
import { defaultLocale } from "lib/i18n";
import { LANGUAGE_LOCALSTORAGE_KEY } from "config/localStorage";
export default function HomePage ({ showRedirectModal, redirectPopupTimestamp }) {
  const currentLanguage = useRef(localStorage.getItem(LANGUAGE_LOCALSTORAGE_KEY) || defaultLocale);
  const isHome = isHomeSite();
  const { chainId } = useChainId();
  const { active } = useWeb3React();

  const changeNetwork = useCallback(
    (network) => {
      if (network === chainId) {
        return;
      }
      if (!active) {
        setTimeout(() => {
          return switchNetwork(network, active);
        }, 500);
      } else {
        return switchNetwork(network, active);
      }
    },
    [chainId, active]
  );

  const BuyLink = ({ className, to, children, network }) => {
    if (isHome && showRedirectModal) {
      return (
        <HeaderLink
          to={to}
          className={className}
          redirectPopupTimestamp={redirectPopupTimestamp}
          showRedirectModal={showRedirectModal}
        >
          {children}
        </HeaderLink>
      );
    }

    return (
      <Link to={to} className={className} onClick={() => changeNetwork(network)}>
        {children}
      </Link>
    );
  };

  return (
    <>
      <div className="MaxBox" id="box">
        <div className="bannerBr">
          {/* <img src={bannerBr1} className="banImg" /> */}
          <div className="home-banner">
            <div className="banner-content">
              <div className={currentLanguage.current === 'en' ? 'banner-title banner-title-isEn' : 'banner-title banner-title-isZh'}>
                <Trans>Decentralized and secure and transparent</Trans><br />
                <Trans>Perpetual leveraged contract platform</Trans>
              </div>
              <div className={currentLanguage.current === 'en' ? 'banner-introduce banner-introduce-isEn' : 'banner-introduce banner-introduce-isZh'}>
                <Trans>Safe and transparent</Trans><br />
                <div style={{ display: currentLanguage.current === 'zh' ? 'block' : 'none' }}><Trans >100% dividend of platform income</Trans></div>
              </div>
              <div className="banner-btn">
                {/* <Link className="trade-btn App-card-option" to="/trade">
                  trade now
                </Link> */}
                {/* <HeaderLink
                  className="App-hide trade-btn App-card-option"
                   to="/trade"
                  redirectPopupTimestamp={redirectPopupTimestamp}
                  showRedirectModal={showRedirectModal}
                >
                  <Trans>trade now</Trans>
                </HeaderLink> */}
                <div className="App-hide trade-btn App-card-option"><Trans>trade now</Trans></div>
                <button className="App-hide watch-btn">
                  <span>
                    <Trans>watch the video</Trans>
                  </span>
                  <img src={Watch} alt="watch" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="small-banerBr">
          <img src={smallBannerBr} alt="smallBannerBr" />
        </div>
        <div className="default-container page-layout  homePage">
          <div className="home-top">
            <div className="title">
              <Trans>4 major advantages</Trans>
            </div>
            <div className="list-card">
              <div className="card">
                <div className="card-left">
                  <img src={CardImg1} alt="CardImg" />
                </div>
                <div className="card-right">
                  <div className="card-right-title">
                    <Trans>Zero Price Impact & Low Liquidation Risks</Trans>
                  </div>
                  <div className="card-right-describe">
                    <Trans>Regardless of the size of the order</Trans>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-left">
                  <img src={CardImg2} alt="CardImg" />
                </div>
                <div className="card-right">
                  <div className="card-right-title">
                    <Trans>Unmanaged and transparent</Trans>
                  </div>
                  <div className="card-right-describe">
                    <Trans>Maintain control</Trans>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-left">
                  <img src={CardImg3} alt="CardImg" />
                </div>
                <div className="card-right">
                  <div className="card-right-title">
                    <Trans>Earn bonuses when staking or trading</Trans>
                  </div>
                  <div className="card-right-describe">
                    <Trans>Earn ETH or esAVT</Trans>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-left">
                  <img src={CardImg4} alt="CardImg" />
                </div>
                <div className="card-right">
                  <div className="card-right-title">
                    <Trans>Safe fast and low gas</Trans>
                  </div>
                  <div className="card-right-describe">
                    <Trans>Optimism</Trans>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="home-center">
            <div className="center-content">
              <div className="centerImg">
                <img src={centerImg} alt="" />
              </div>

              <div className={currentLanguage.current === 'en' ? 'title title-isEn' : 'title title-isZh'}>
                <Trans>Provide liquidity to earn bonuses</Trans>
              </div>
              <div className={currentLanguage.current === 'en' ? 'text text-isEn' : 'text text-isZh'}>
                <div>
                  <Trans>
                    Provide BTC, ETH, OP, or Stablecoins to Mint ALP<br />
                    Automatically earn 80% of platform fees
                  </Trans>
                </div>
              </div>
              <button className="homebtn">
                <Trans>Stake and Earn</Trans>
              </button>
            </div>
            <div className="center-content">
              <div className="centerImg">
                <img src={centerImg1} alt="" />
              </div>
              <div className={currentLanguage.current === 'en' ? 'title title-isEn' : 'title title-isZh'}>
                <Trans>long or short</Trans>
              </div>
              <div className={currentLanguage.current === 'en' ? 'text text-isEn' : 'text text-isZh'}>
                {/* <div>
                  <Trans>long or short</Trans>
                </div> */}
                <div>
                  <Trans>
                    Swap, Long or Short To Earn Rewards From Trading Fees<br />
                    The Higher Your Trades, The Higher the Rewards
                  </Trans>
                </div>
              </div>
              {/* <button className="homebtn">
                <Trans>trade and earn</Trans>
              </button> */}
              {/* <Link className="homebtn" to="/trade">
                trade and earn
              </Link> */}
              {/* <HeaderLink
                className="homebtn"
                to="/trade"
                redirectPopupTimestamp={redirectPopupTimestamp}
                showRedirectModal={showRedirectModal}
              >
                <Trans>trade and earn</Trans>
              </HeaderLink> */}
              <div className="homebtn"><Trans>trade and earn</Trans></div>
            </div>
          </div>
          <div className="home-footer">
            <div className="contact">
              <Trans>Welcome to contact us</Trans>
            </div>
            {/* <div className="email">联系邮箱</div> */}
            {/* <div className="emailadress">bd@avt.com</div> */}
            <div className="Footer-social-link-block">
              <a href="https://bit.ly/3Z3ZrrD" target="_blank" className="App-social-link">
                <img src={frameIcon} alt="" className="big" />
                <img src={smallFrameIcon} alt="" className="small" />
              </a>
              <a href="https://twitter.com/AVTtrade" target="_blank" className="App-social-link">
                <img src={twitterIcon} alt="" className="big" />
                <img src={smallTwitterIcon} alt="" className="small" />
              </a>
              <a href="https://medium.com/@avttrade" target="_blank" className="App-social-link">
                <img src={mediumIcon} alt="" className="big" />
                <img src={smallMediumIcon} alt="" className="small" />
              </a>
              <a href="https://t.me/AVTWorld" target="_blank" className="App-social-link">
                <img src={telegramIcon} alt="" className="big" />
                <img src={smallTelegramIcon} alt="" className="small" />
              </a>
              <a href="https://discord.gg/DprCJcfCyg" target="_blank" className="App-social-link">
                <img src={githubIcon} alt="" className="big" />
                <img src={smallDiscordIcon} alt="" className="small" />
              </a>
              <a href="https://bit.ly/3QcNko9" target="_blank" className="App-social-link">
                <img src={youtubeIcon} alt="" className="big" />
                <img src={smallYoutubeIcon} alt="" className="small" />
              </a>
            </div>
          </div>
        </div>
        <Footer isHomePage={true} />
      </div>
    </>
  )
}





